module.exports = __webpack_public_path__ + "static/media/plane-left2right.57aaf5ab.svg";